import { WorkScheduleService } from "./../../../services/catalogs/WorkScheduleService";
import React from "react";
import { WorkScheduleDetail } from "../../../components/Pages/Catalogs/WorkSchedule/WorkScheduleDetail";
import { CreateWorkScheduleDto } from "../../../dtos/catalogs/workschedule/CreateWorkScheduleDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupWorkSchedule } from "../../../components/Shared/NewForms/NFLookupWorkSchedule";
import WorkScheduleList from "../../../components/Pages/Catalogs/WorkSchedule/WorkScheduleList";

export const WorkSchedule: IAppEntity = {
  entityType: "catalog",
  title: "WorkSchedule",
  pluralTitle: "WorkSchedule",
  apiUrl: "WorkSchedules",
  apiEnum: ReferenceTypes.CatalogWorkSchedule,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(WorkScheduleDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(WorkScheduleList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupWorkSchedule, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new WorkScheduleService(this.apiUrl);
  },
  getEmptyModel(): CreateWorkScheduleDto {
    return {
      name: "",
      createdDate: new Date(),
    };
  },
};
